import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;
